import React, { useEffect, useRef } from "react";
import moment from "moment";
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import "../datePicker/datePicker.scss";

const DatePicker = ({ value, onChange }) => {
    const [currentMonth, setCurrentMonth] = React.useState(moment(value.startDate).startOf('month'));
    const [modalOpen, setModalOpen] = React.useState(null);

    // Ref für das Modal
    const containerRef = useRef(null);

    const startDay = moment(currentMonth).startOf('month').startOf('week');
    const endDay = moment(currentMonth).endOf('month').endOf('week');

    const calendarDays = [];
    let day = startDay.clone();

    while (day.isSameOrBefore(endDay, 'day')) {
        calendarDays.push(day.clone());
        day.add(1, 'day');
    }

    const handleDateClick = (clickedDay) => {
        const clicked = clickedDay.startOf("day");

        if (modalOpen === "start") {
            onChange({
                ...value,
                startDate: clicked.toISOString(),
                endDate: null,
            });
            setModalOpen("end");
        } else if (modalOpen === "end") {
            onChange({
                ...value,
                endDate: clicked.toISOString(),
            });
            setTimeout(() => {
                setModalOpen(null);
            }, 150);
        }
    };


    const onStartTimeChange = (e) => {
        const newStartTime = e.target.value;

        onChange({ ...value, startTime: newStartTime });
    };

    const onEndTimeChange = (e) => {
        const newEndTime = e.target.value;

        onChange({ ...value, endTime: newEndTime });
    };

    const toggleGanztags = () => {
        const isGanztags = !value.ganztags;

        if (isGanztags) {

            onChange({
                ganztags: true,
                startTime: "00:00",
                endTime: "23:59",
            });
        } else {
            onChange({
                ganztags: false,
                startTime: "07:00",
                endTime: "12:00",
            });
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setModalOpen(false);
            }
        };

        if (modalOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [modalOpen]);

    return (
        <div className="datePicker">
            <div className="date">
                <span className={modalOpen === "start" ? "picker active" : "picker"} onClick={() => setModalOpen("start")}>
                    {moment(value.startDate).format("dd, DD. MMM")}
                </span>
                <span>-</span>
                <span className={modalOpen === "end" ? "picker active" : "picker"} onClick={() => setModalOpen("end")}>
                    {value.endDate ? moment(value.endDate).format("dd, DD. MMM") : "Datum wählen"}
                </span>
            </div>
            {modalOpen &&
                <div className="dateModal" ref={containerRef}>
                    <div className="navigate">
                        <KeyboardArrowLeftIcon onClick={() => setCurrentMonth(prev => moment(prev).subtract(1, 'month'))} />
                        <span>{currentMonth.format("MMMM YYYY")}</span>
                        <KeyboardArrowRightIcon onClick={() => setCurrentMonth(prev => moment(prev).add(1, 'month'))} />
                    </div>
                    <div className="weekDays">
                        {["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"].map((day, index) => (
                            <div className="weekDay" key={index}>{day}</div>
                        ))}
                    </div>
                    <div className="calendarGrid">
                        {calendarDays.map((day, index) => {
                            const isSelectedStart = moment(day).isSame(value.startDate, 'day');
                            const isSelectedEnd = moment(day).isSame(value.endDate, 'day');
                            const isBetween = moment(day).isAfter(value.startDate, 'day') && moment(day).isBefore(value.endDate, 'day');
                            const isToday = moment().isSame(day, 'day');

                            return (
                                <div
                                    key={index}
                                    className={[
                                        "day",
                                        day.month() !== currentMonth.month() && "otherMonth",
                                        isSelectedStart && "startDate",
                                        isSelectedEnd && "endDate",
                                        isBetween && "inRange",
                                        isToday && "isToday"
                                    ].filter(Boolean).join(" ")}
                                    onClick={() => handleDateClick(day)}
                                >
                                    {day.date()}
                                </div>
                            );
                        })}
                    </div>
                </div>
            }
            <div className="time">
                {value.ganztags ? (
                    <button className="secondary" type="button" onClick={toggleGanztags}>Uhrzeit hinzufügen</button>
                ) : (
                    <div className="timePickers">
                        <input type="time" value={value.startTime} onChange={onStartTimeChange} />
                        <span>-</span>
                        <input type="time" value={value.endTime} onChange={onEndTimeChange} />
                        <button className="secondary" type="button" onClick={toggleGanztags}>
                            <CloseIcon />
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default DatePicker;